<template>
  <div class="brandIdBlock">
    <div class="brandId-row" v-for="shop in shopList" :key="shop.id">
      <el-form ref="brandForm" :model="shop" style="margin-bottom: 15px">
        <el-form-item prop="id" :rules="itemRules(shop)">
          <el-image :src="shop.icon" style="width: 26px; height: 26px; border-radius: 50%"></el-image>
          <el-tooltip v-if="shop.channelIcon" :content="shop.channelName" style="margin: 0px -6px 0px 6px">
            <el-image :src="shop.channelIcon" style="width: 18px; height: 18px"></el-image>
          </el-tooltip>
          <span class="shop-title">
            <em v-if="shop.required" class="required">*</em>
            {{ shop.shortTitle || shop.title }}
          </span>
          <el-select
            :value="valueMap[shop.id]"
            value-key="vid"
            name-key="propValue"
            :filterable="filterable"
            @change="v => selectChange(v)"
            @focus="() => selectFocus(shop.id)"
          >
            <template v-if="brandOptions[shop.id]">
              <el-option
                v-for="brandOp in brandOptions[shop.id].renderOptions"
                :key="brandOp.vid"
                :label="brandOp.propValue"
                :value="brandOp"
              >
              </el-option>
            </template>
          </el-select>
          <!-- <el-link
            v-if="(valueMap && valueMap[shop.id] && valueMap[shop.id].propValue) || ''"
            style="margin-left: 8px"
            @click="handleSetToShop(shop, valueMap && valueMap[shop.id] && valueMap[shop.id].propValue)"
            >应用到其他店铺
          </el-link> -->
          <span v-if="getFail[shop.id]" class="error-text">{{
            getFail[shop.id] === true ? '店铺订购应用已过期，请重新订购以获取店铺品牌' : getFail[shop.id]
          }}</span>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog-select-shop
      v-if="shopDialogVisible"
      :visible.sync="shopDialogVisible"
      :shopData="shopList"
      placeholder="店铺名称"
      @confirm="confirmSelectShop"
    ></el-dialog-select-shop>
  </div>
</template>

<script>
// import { getPddCategoryPropertiesNew, getApplyBrandConfig, getBrandList } from '@/servers/prod/center/temu.js';
import { getBrandList } from '@/servers/prod/center/temu.js';
import { ApplyToOtherShop } from '@/servers/prod/center/fxg.js';

import { cloneDeep } from 'lodash';
const PLATFORMID = 'PinShop';
export default {
  name: 'BrandIdBlock',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    brandProp: {
      type: Object,
      default() {
        return {};
      },
    },
    shopList: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    filterable: {
      type: Boolean,
      default: false,
    },
    remote: {
      type: Boolean,
      default: false,
    },
    categoryId: [String, Number],
    baseItemId: [String, Number],
  },
  data() {
    return {
      valueMap: {},
      brandOptions: {},
      loading: {},
      getFail: {},
      shopDialogVisible: false,
      selectShopIds: '',
      applyShopName: '', //发货时效应用的店铺名称
      applyShopObj: [], //发货时效应用的店铺对象
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(v) {
        if (v && v.length) {
          v.forEach(item => {
            this.$set(this.valueMap, item.shopId, item);
          });
        }
      },
    },
  },
  methods: {
    itemRules(shop) {
      const validShop = (rule, value, callback) => {
        if (!shop.required) {
          return callback();
        }
        const itemValue = this.valueMap[shop.id];
        if (!itemValue) {
          return callback(new Error('该类目下品牌必填，品牌为空不支持商品发布'));
        }
        return callback();
      };
      return [{ required: shop.required, validator: validShop }];
    },
    async method_validate() {
      let validSuccess = false;
      const brandForm = this.$refs.brandForm;
      const promiseALL = [];
      (brandForm || []).forEach(item => {
        promiseALL.push(
          new Promise(resolve => {
            item.validate(valid => {
              resolve(valid);
            });
          })
        );
      });
      return new Promise(resolve => {
        Promise.all(promiseALL)
          .then(results => {
            validSuccess = results.every(item => {
              return item === true;
            });
            resolve(validSuccess);
          })
          .catch(() => {
            resolve(false);
          });
      });
    },
    selectFocus(shopId) {
      if (!this.brandOptions[shopId]) {
        this.getShopBrandList(shopId);
      }
    },
    selectChange(v) {
      let newVal = cloneDeep(this.value);
      let oindex = newVal.findIndex(({ shopId }) => shopId === v.shopId);
      if (oindex > -1) {
        newVal.splice(oindex, 1, v);
      } else {
        newVal.push(v);
      }

      this.changeVal(newVal);
    },
    changeVal(newVal) {
      newVal.forEach(item => {
        const channel = this.shopList.find(shop => shop.id == item.shopId)?.channel;
        item.channel = channel;
      });
      console.log(cloneDeep(newVal), '----changeVal----');

      this.$emit('change', newVal);
    },
    remoteMethod(queryText, shopId) {
      // if (queryText === '') {
      const options = this.brandOptions[shopId].originOptions;
      this.brandOptions[shopId].renderOptions = cloneDeep(options);
      return false;
      // }
      if (!this.brandOptions[shopId]) {
        // this.brandOptions[shopId].renderOptions = []
        return false;
      }
      const { refPid, catId } = this.brandOptions[shopId];
      getPddCategoryPropertiesNew(
        {
          refPid,
          catId,
          value: queryText,
          pageSize: 50,
        },
        shopId
      ).then(res => {
        const { goodsTemplatePropValSearchResponse = {} } = res;
        const { list = [] } = goodsTemplatePropValSearchResponse;
        list.map(item => {
          item.propValue = item.value;
          item.shopId = shopId;
          item.refPid = refPid;
          return item;
        });
        this.brandOptions[shopId].renderOptions = cloneDeep(list);
      });
    },
    async getShopBrandList(shopId) {
      const categoryId = this.categoryId;
      if (!categoryId || !shopId) return;
      // this.$set(this.loading, shopId, true);
      this.getFail = {};
      try {
        const data = await getBrandList({
          shopId,
          // categoryId,
          // pageSize: 10,
        });
        // this.loading[shopId] = false;
        let options = data.map(item => {
          return {
            shopId,
            vid: item.vid,
            pid: item.pid,
            propValue: item.brandNameEn,
            valueUnit: '',
            templatePid: this.brandProp.templatePid,
            propName: this.brandProp.name,
            refPid: this.brandProp.refPid,
          };
        });

        this.$set(this.brandOptions, shopId, {
          refPid: this.brandProp.refPid,
          catId: categoryId,
          renderOptions: cloneDeep(options),
          originOptions: cloneDeep(options),
        });
      } catch (error) {
        console.log(error, '-----error');
      }
    },

    async getApplyToOtherShop(payload) {
      const params = {
        ...payload,
      };
      const res = await ApplyToOtherShop(params);
      return res;
    },
    handleSetToShop(promiseConf, applyShopName) {
      this.applyShopObj = promiseConf;
      this.shopDialogVisible = true;
      this.applyShopName = applyShopName;
    },
    confirmSelectShop(shops) {
      this.shopDialogVisible = false;
      this.$confirm(`选中店铺将匹配品牌【${this.applyShopName}】，匹配后将覆盖原品牌值，未匹配到将跳过，是否确认`, '提示', {
        confirmButtonText: '确定',
        type: 'warning',
      })
        .then(async () => {
          const categoryId = this.categoryId;
          const shopIds = shops.map(item => item.id);
          const params = {
            shopType: PLATFORMID,
            shopIds: shopIds.join(','),
            categoryId,
            brandName: this.applyShopName && this.applyShopName.includes('/') ? this.applyShopName.split('/')[1] : this.applyShopName || '',
          };

          const res = await this.getApplyToOtherShop(params);
          const dataKeys = Object.keys(res);
          const dataKeysValue = Object.keys(this.valueMap);
          // for(const key in this.valueMap){
          //   if(dataKeys.includes((key))){
          //     const shopInfo = res[key];
          //     this.valueMap[key] = {...shopInfo,shopId: key}
          //   }
          // }
          const newValue = [];
          for (const key in res) {
            const shopInfo = res[key];
            // this.valueMap[key] = { ...shopInfo,shopId: Number(key) }
            const item = { ...shopInfo, shopId: Number(key) };
            this.$set(this.valueMap, key, item);
            newValue.push(item);
            // this.selectChange(this.valueMap[key]);
          }
          this.value.map(item => {
            const index = newValue.findIndex(({ shopId }) => shopId == item.shopId);
            if (index == -1) {
              newValue.push(item);
            }
          });
          console.log(newValue, this.value, 999);
          this.changeVal(newValue);
          this.$message.success('更新品牌成功！');
        })
        .catch(() => {
          // this.$message.error('更新品牌失败！')
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.brandId-row {
  display: flex;
  align-items: center;
  ::v-deep .el-image {
    display: inline-block;
    vertical-align: middle;
  }
  .shop-title {
    display: inline-block;
    vertical-align: middle;
    .required {
      color: #f56c6c;
    }
  }
}
.error-text {
  color: #f56c6c;
  font-size: 12px;
  margin-left: 10px;
}
</style>